// Parses executionData + eventData into human-readable essential info (no raw JSON / MongoDB).

const ACTION_LABELS = {
  suggest_template: 'Suggest template',
  show_notification: 'Show notification',
  create_task: 'Create task',
  create_calendar_event: 'Create calendar event',
  prompt_time_entry: 'Prompt time entry',
  send_email: 'Send email',
};

function fmtDate(d) {
  if (!d) return '';
  const x = new Date(d);
  return isNaN(x.getTime()) ? '' : x.toLocaleDateString(undefined, { dateStyle: 'medium' }) + ' ' + x.toLocaleTimeString(undefined, { timeStyle: 'short' });
}

function stepSummary(stepKey, step) {
  const actionType = (stepKey.match(/step_\d+_(.+)/) || [])[1] || '';
  const label = ACTION_LABELS[actionType] || actionType;
  if (!step.success) return { actionLabel: label, success: false, summary: step.error || 'Failed' };
  const r = step.result || {};
  if (actionType === 'prompt_time_entry' && r.notification) {
    return { actionLabel: label, success: true, summary: r.notification.subject || 'Timesheet prompt sent' };
  }
  if (r.notification) {
    const sub = r.notification.subject;
    return { actionLabel: label, success: true, summary: sub ? `Notification: ${sub}` : 'Notification created' };
  }
  if (r.task) {
    const sub = r.task.subject || '';
    const due = fmtDate(r.task.dueDate);
    return { actionLabel: label, success: true, summary: due ? `Task: ${sub || 'Task'}, due ${due}` : (sub || 'Task created') };
  }
  if (r.appointment) {
    const sub = r.appointment.subject || '';
    const start = fmtDate(r.appointment.startDate);
    return { actionLabel: label, success: true, summary: start ? `Event: ${sub || 'Event'}, ${start}` : (sub || 'Calendar event created') };
  }
  if (actionType === 'send_email' && step.success) {
    return { actionLabel: label, success: true, summary: 'Email sent' };
  }
  return { actionLabel: label, success: true, summary: 'Done' };
}

export function formatExecutionDetails(execution) {
  const ed = execution?.executionData || {};
  const ev = execution?.eventData || {};
  const steps = Object.keys(ed)
    .filter((k) => k.startsWith('step_'))
    .sort()
    .map((k) => ({ key: k, ...stepSummary(k, ed[k]) }));

  let eventContext = '';
  const docTitle = ev.document?.title || ev.document?.originalFilename;
  const caseName = ev.caseFile?.name || ev.caseFile?.fileNo;
  if (docTitle && caseName) eventContext = `Document "${docTitle}" for case "${caseName}"`;
  else if (docTitle) eventContext = `Document "${docTitle}"`;
  else if (caseName) eventContext = `Case "${caseName}"`;
  else if (ev.templateId) eventContext = 'Document from template';
  else if (ev.emailTemplateId) eventContext = 'Email template sent';
  else eventContext = '—';

  // For cancelled executions, steps may be empty
  return { eventContext, steps };
}
